// @ts-nocheck
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import PropTypes from 'prop-types';

const styles = {
  root: {
    margin: '1em',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    transition: 'all 0.25s',
    height: 44,
    boxSizing: 'border-box',
    boxShadow: 'none',
    background: 'transparent',
  },
  input: {
    paddingLeft: 16,
    flex: 1,
    transition: 'all 0.2s',
    color: '#1a1a1a',
    height: '100%',
    '& input': {
      padding: 0,
    },
    border: '1px solid #d1d5db',
    borderRadius: 12,
    backgroundColor: '#ffffff',
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    '&:focus-within': {
      borderColor: 'rgba(223, 109, 46, 0.5)',
      boxShadow: '0 0 0 2px rgba(223, 109, 46, 0.12)',
    },
  },
  focused: {
    opacity: 1,
    color: '#1a1a1a !important',
  },
  iconButton: {
    width: 44,
    height: 44,
    border: '1px solid #d1d5db',
    borderRadius: 12,
    backgroundColor: '#ffffff',
    color: '#6b7280',
    flexShrink: 0,
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: '#f9fafb',
      borderColor: 'rgba(223, 109, 46, 0.5)',
      color: 'var(--color-primary)',
    },
  },
  clearButton: {
    position: 'absolute',
    zIndex: 999,
  },
};

const useStyles = makeStyles(styles);

function SearchBar(props) {
  const classes = useStyles();
  const [focusBar, setFocusBar] = useState(false);
  const [searchText, setSearchText] = useState('');
  const { onSubmit, onChange } = props;

  const textChanged = (text) => {
    setSearchText(text);
    if (onChange) {
      onChange(text);
    }
  };

  const submitHandler = () => {
    if (onSubmit) {
      onSubmit(searchText);
    }
  };

  const keySubmitHandler = (e) => {
    if (e.keyCode === 13) {
      submitHandler();
    }
  };

  const mouseEnterHander = () => setFocusBar(true);
  const mouseLeaveHandler = () => setFocusBar(false);
  const changeHander = (e) => textChanged(e.target.value);

  return (
    <Paper className={classes.root}>
      <InputBase
        className={`${classes.input} ${focusBar ? classes.focused : ''}`}
        classes={{ focused: classes.focused }}
        placeholder="Search"
        value={searchText}
        onChange={changeHander}
        onKeyDown={keySubmitHandler}
        onMouseEnter={mouseEnterHander}
        onMouseLeave={mouseLeaveHandler}
      />

      {searchText && (
        <IconButton
          onClick={() => textChanged('')}
          color="default"
          className={classes.clearButton}
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      )}
      <IconButton className={classes.iconButton} onClick={submitHandler}>
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}

SearchBar.propTypes = {
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default SearchBar;
